exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mail-buttons-container[data-v-a95db88e] {\n  width: 100%;\n  display: flex;\n  justify-content: flex-start;\n  margin-bottom: 20px;\n}\n.disabled[data-v-a95db88e] {\n  background-color: #f6f8f9;\n  color: #616f7b;\n  border: 1px solid #616f7b;\n}", ""]);

// exports
